// extracted by mini-css-extract-plugin
module.exports = {"labels":"Tags-module--labels--1QBoi","label":"Tags-module--label--3Mycy"};